import { MaintenanceBanner, UpgradeBadge } from '@va/dashboard/components';
import { PreHeaderBadge } from '@va/ui/design-system';
import { LimitReachedBadge } from '../misc/PreHeaderBadges';

export const LayoutPreHeader = () => {
  return (
    <div className='flex flex-col pt-18px pl-18px pb-6px pr-6px gap-3 order-second empty:hidden'>
      <MaintenanceBanner render={(message) => <PreHeaderBadge message={message} />} />
      <LimitReachedBadge />
      <UpgradeBadge />
    </div>
  );
};
